var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkFixed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.100342,
    y: 0.82695,
    width: 56.346,
    height: 56.346,
    rx: 28.173,
    fill: "#F5FFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-18 28.27 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.27,
    y: 19,
    width: 26,
    height: 20,
    rx: 5,
    fill: "#00A6A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.77,
    y: 19.5,
    width: 25,
    height: 19,
    rx: 4.5,
    stroke: "#474D54",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24.5,
    r: 2.6,
    fill: "#F5FFFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 29.3,
    y: 34,
    textAnchor: "middle",
    fontFamily: "Archivo, IBM Plex Sans, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12.5,
    fill: "#F5FFFF"
  }, "\u20B5"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFixed);
export default __webpack_public_path__ + "static/media/LinkFixed.ba6829387cc3cfa8eaa0a6bfd210f51a.svg";
export { ForwardRef as ReactComponent };